import PantryPopup from '@/components/pantry/PantryPop';
import { CroppedImage } from '@weee-fe/module';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ComponentProps } from '@/types/cms';

const HIDE_PANTRY_INTRODUCE_COMP = 'hide_pantry_introduce_comp';

type IntroduceProps = {
  page?: string;
} & ComponentProps;

const Introduce = (props: IntroduceProps) => {
  const { properties, page } = props;
  const [showThisComp, setShowThisComp] = useState(false);
  const pantryPopRef = useRef<any>(null);

  const onClickLeftBtn = useCallback(() => {
    const _link = properties?.left_btn_link;
    if (!_link) return;
    if (_link.includes('/pantry/faq')) {
      pantryPopRef.current.show();
    }
  }, [properties.left_btn_link]);

  const onClickRightBtn = useCallback(() => {
    if (page === 'pantry') {
      localStorage.setItem(HIDE_PANTRY_INTRODUCE_COMP, 'true');
      setShowThisComp(false);
    }
  }, [page]);

  useEffect(() => {
    if (page === 'pantry') {
      const isHide = localStorage.getItem(HIDE_PANTRY_INTRODUCE_COMP);
      if (isHide === 'true') {
        setShowThisComp(false);
        return;
      }
      setShowThisComp(true);
    }
  }, [page]);

  if (!showThisComp) return null;

  return (
    <>
      <div
        className="flex border-surface-100-hairline border-solid border rounded-2xl mx-5 my-3"
        style={{
          boxShadow: '0px 14px 32px 0px rgba(0, 0, 0, 0.05), 0px 0px 6px 0px rgba(0, 0, 0, 0.05);'
        }}>
        <div className="flex-1 flex flex-col py-2 px-3 justify-center">
          <div
            className="enki-body-xs-medium mb-3"
            style={{
              color: properties.title_color
            }}>
            {properties.title}
          </div>
          <div className="flex items-center gap-x-2">
            <button
              className="px-3 py-1.5 rounded-full enki-body-xs-medium"
              onClick={() => onClickLeftBtn?.()}
              style={{
                backgroundColor: properties.left_btn_bg_color,
                color: properties.left_btn_fg_color
              }}>
              {properties.left_btn_text}
            </button>
            <button
              className="px-3 py-1.5 rounded-full bg-white enki-body-xs-medium"
              onClick={() => onClickRightBtn?.()}
              style={{
                backgroundColor: properties.right_btn_bg_color,
                color: properties.right_btn_fg_color
              }}>
              {properties.right_btn_text}
            </button>
          </div>
        </div>
        <div
          className="flex-none w-[93px] rounded-r-2xl overflow-hidden"
          style={{
            backgroundColor: properties.image_theme_color
          }}>
          <CroppedImage
            url={properties.image_url}
            alt=""
            aria-hidden={true}
            wrapperClassName="w-[93px] h-full flex items-center justify-center aspect-square"
            className="w-[90px]"
          />
        </div>
      </div>

      <PantryPopup ref={pantryPopRef} onlyShowFAQ={true}></PantryPopup>
    </>
  );
};

export default Introduce;
